import React from 'react';
import { useParams } from 'react-router-dom-v5-compat';
import RecurringInvoiceForm from '@/components/MakeRecurringInvoice';
import { Redirect, SEO } from '@/components/common';
import { Container, Layout } from '@/containers';
import { useSetIMPageType } from '@/hooks';
import { setHotjarPage } from '@/util';

const RecurringInvoice = () => {
    const params = useParams();

    const { documentLoading, redirect } = useSetIMPageType({
        params,
        documentType: 'recurring-invoice'
    });

    // Allows redirection of page if this component/URL is not correct.
    if (!documentLoading && redirect) {
        return <Redirect to={redirect} />;
    }

    setHotjarPage({ page: 'Make Recurring Invoice' });

    return (
        <Layout>
            <Container>
                <SEO title="Make a Recurring Invoice" />
                <RecurringInvoiceForm isLoading={documentLoading} recurring />
            </Container>
        </Layout>
    );
};

export default RecurringInvoice;
